import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'date',
})
export class DatePipe implements PipeTransform {
  transform(value: any, format: string = 'MMMM D, YYYY'): any {
    if (value !== undefined) {
      return dayjs(value).format(format);
    }
  }
}
